<template>
  <div style="background-color: #ffffff">
    <div class="f6-container" style="background-color: #ffffff" data-aos="fade-up">
      <div style="
          font-weight: bold;
          font-size: 32px;
          color: #222222;
          padding-top: 71px;
        ">
        机器人业务 · 智慧场景赋能
      </div>

      <div style="font-size: 16px;color: #595859;line-height: 21px;text-align: center;">智能机器人赋能智慧场景，助力企业自动化升级</div>

      <video class="video" ref="videoElement" :src="currentVideoSrc" muted autoplay @canplay="onCanPlay"
        @ended="onVideoEnded" @timeupdate="onTimeUpdate" v-if="showVideo">
        您的浏览器不支持 video 标签。
      </video>

      <div class="bottom">
        <div v-for="(item, index) in dataList" class="f6-item" @click="handleClick(index)">
          <div class="line">
            <div v-if="index == currentIndex" class="blueline" :class="{ active: isAnimating }"></div>
          </div>
          <div class="title" v-html="item.title"></div>
          <div class="subtitle" v-html="item.subtitle"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    // videoPlayer
  },
  data() {
    // 确保 playerOptions 是响应式的
    return {
      currentVideoSrc: "https://static.htd.cn/mobileapp/html/video/video-1.mp4",
      currentIndex: 0,
      showVideo: true,
      videoSources: [
        "https://static.htd.cn/mobileapp/html/skwebsite/4-LM200.webm",
        // "https://static.htd.cn/mobileapp/html/skwebsite/%E6%A8%A1%E5%9D%974-LM201.mp4",
        "https://static.htd.cn/mobileapp/html/skwebsite/4-LM202.webm",
        "https://static.htd.cn/mobileapp/html/skwebsite/4-LM203.webm",
        "https://static.htd.cn/mobileapp/html/skwebsite/4-LM211.webm",
      ],
      dataList: [
        {
          title: "LM200<br>AI智能零售巡检机器人",
          subtitle:
            "专为线下无人零售店及中小型商超打造，整合自主导航、视觉识别与人机交互功能，覆盖导购、运营与巡检场景，提供轻量化智能零售解决方案。",
        },
        {
          title: "LM202<br>AI智能零售巡检机器人",
          subtitle:
            "面向线下无人零售店和中大型商超，提供零售服务与运营管理解决方案，具备自主导航、AI视觉识别、人机交互等能力，覆盖导购、运营、巡检三大场景。",
        },
        {
          title: "LM203<br>AI智能安保巡逻机器人",
          subtitle:
            "基于园区级L4低速无人驾驶技术打造，集成多传感器融合感知、厘米级高精度定位与AI智能识别算法，可在复杂环境中自主运行、智能巡检与主动安防。",
        }, {
          title: "LM211<br>AI智能零售机器人",
          subtitle:
            "具备货物分拣、货架整理等功能，可迎宾导购、人机互动替代人工重复作业，节约基础人力成本",
        },
      ],
      progress: 0,
      isAnimating: false,
    };
  },
  mounted() {
    this.currentVideoSrc = this.videoSources[0];
  },
  methods: {
    handleClick(index) {
      this.currentIndex = index;
      this.showVideo = false;
      this.progress = 0;
      this.currentVideoSrc = this.videoSources[this.currentIndex];
      this.$nextTick(() => {
        this.showVideo = true;
      });
    },
    changeVideo() {
      const currentIndex = this.videoSources.indexOf(this.currentVideoSrc);
      const nextIndex = (currentIndex + 1) % this.videoSources.length;
      this.currentVideoSrc = this.videoSources[nextIndex];

      // 触发视频重新加载
      this.$refs.videoElement.load();
    },
    onCanPlay() {
      console.log("视频已准备好播放");
      this.isAnimating = true;
    },
    onVideoEnded() {
      if (this.currentIndex == 3) {
        this.currentIndex = 0;
      } else {
        this.currentIndex++;
      }
      this.currentVideoSrc = this.videoSources[this.currentIndex];

      // 触发视频重新加载
      this.$refs.videoElement.load();
      this.progress = 0;
    },
    onTimeUpdate(event) {
      const video = event.target;
      this.progress = (video.currentTime / video.duration) * 100;
    },
  },
};
</script>

<style lang="less" scoped>
.f6-container {
  background-color: #ffffff;
  width: 1200px;
  margin: 0 auto;
}

.video {
  width: 100%;
  height: 440px;
  margin: 0 auto;
  margin-top: 45px;
  border-radius: 5px;
}

.bottom {
  width: 100%;
  margin-top: 30px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  .f6-item {
    height: 259px;
    width: 250px;

    .line {
      width: 100%;
      height: 2px;
      background: #dde2e9;
      position: relative;
    }

    .title {
      margin-top: 25px;
      font-weight: bold;
      font-size: 22px;
      color: #222222;
      text-align: left;
      line-height: 26px;
      margin-bottom: 10px;

      &:hover {
        cursor: pointer;
      }
    }

    .subtitle {
      font-size: 14px;
      color: #222222;
      line-height: 24px;
      text-align: left;
    }
  }
}

.blueline {
  position: absolute;
  left: 0;
  bottom: 0;
  top: 0;
  background: #1763ff;
  animation: grow 9s linear forwards;
}

@keyframes grow {
  from {
    width: 0%;
  }

  to {
    width: 100%;
  }
}
</style>
<div v-if="index == currentIndex" class="blueline" :class="{ active: isAnimating }"></div>
